import { render } from "./Lista.vue?vue&type=template&id=7250f5a2&scoped=true&ts=true"
import script from "./Lista.vue?vue&type=script&lang=ts"
export * from "./Lista.vue?vue&type=script&lang=ts"

import "./Lista.vue?vue&type=style&index=0&id=7250f5a2&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7250f5a2"]])

export default __exports__